module.exports = __webpack_public_path__ + "img/verka.01d34a72.jpg";